module.exports = __webpack_public_path__ + "static/media/weight-icon.c46c6825.svg";